import { render } from "./AlertScore.vue?vue&type=template&id=61881919&scoped=true"
import script from "./AlertScore.vue?vue&type=script&lang=js"
export * from "./AlertScore.vue?vue&type=script&lang=js"

import "./AlertScore.vue?vue&type=style&index=0&id=61881919&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61881919"]])

export default __exports__